import * as React from "react";

import type { DesignaliProps } from "../../types";

export const HousePlug = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({  ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        
  <path  d="M9.89,12.53v-3.2"/>
  <path  d="M14.11,12.53v-3.2"/>
  <path  d="M15.16,12.53c.58,0,1.05.47,1.05,1.05v2.11c0,1.16-.94,2.11-2.11,2.11h-4.21c-1.16,0-2.11-.94-2.11-2.11v-2.11c0-.58.47-1.05,1.05-1.05h6.32Z"/>
  <path  d="M8.32,22h-3.68c-1.16,0-2.11-.94-2.11-2.11v-9.47c0-.62.27-1.21.75-1.61l7.37-6.31c.78-.66,1.93-.66,2.72,0l7.37,6.31c.47.4.75.99.75,1.61v9.47c0,1.16-.94,2.11-2.11,2.11h-5.26c-1.16,0-2.11-.94-2.11-2.11v-2.11"/>
</svg>
    );
  },
);

export default HousePlug;
